import { render, staticRenderFns } from "./Exemption.vue?vue&type=template&id=4fc2a40e&scoped=true"
import script from "./Exemption.vue?vue&type=script&lang=js"
export * from "./Exemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc2a40e",
  null
  
)

export default component.exports